import React from 'react';
import LoadingOverlay from 'react-loading-overlay';
import './DigitalCatalogDialog.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import API from '../lib/API';

class DigitalCatalogDialog extends React.Component {
  state = {
    loading: false,
    catalogInfo: null,
    leftPage: null,
    rightPage: null,

    leftPageSize: null,
    rightPageSize: null,

    page: 0,
    magnify: 100,

    currentPage:0,
    currentMagnify: 1,
  }
  pageCache = {}
  loadingPageNumbers = [];
  leftPageVisibleTimer = null;
  rightPageVisibleTimer = null;
  dragStart = null;

  componentDidMount = () => {
    this.setState({
      loading: '読み込み中',
    });
    API.getDigitalCatalogInfo(this.props.catalogId)
      .then(catalogInfo => {
        this.setState({ 
          catalogInfo: catalogInfo,
          leftPageSize: {
            width: 0,//catalogInfo.width,
            height: catalogInfo.height
          },
          rightPageSize: {
            width: catalogInfo.width,
            height: catalogInfo.height
          }
        });
        this.bookViewToAll();
        this.loadPages();
      });

    window.addEventListener('blur', this.handleWindowBlur);
    window.addEventListener('focus', this.handleWindowFocus);
    document.addEventListener('keydown', this.handelWindowKeydown);
    document.addEventListener('keyup', this.handelWindowKeyup);
    document.addEventListener('dragstart', this.handleDragstart);
    this.bookWrap.addEventListener('contextmenu', this.handleContextMenu);
    this.bookWrap.addEventListener('wheel', this.handleWheel);
  }
  componentWillUnmount = () => {
    clearTimeout(this.leftPageVisibleTimer);
    clearTimeout(this.rightPageVisibleTimer);
    window.removeEventListener('blur', this.handleWindowBlur);
    window.removeEventListener('focus', this.handleWindowFocus);
    document.removeEventListener('keydown', this.handelWindowKeydown);
    document.removeEventListener('keyup', this.handelWindowKeyup);
    document.removeEventListener('dragstart', this.handleDragstart);
  }

  loadPages = () => {
    clearTimeout(this.leftPageVisibleTimer);
    clearTimeout(this.rightPageVisibleTimer);
    this.setState({
      leftPage:'loading',
      rightPage:'loading'
    });
    
    this.loadLeftPage(this.state.currentPage);
    this.loadRightPage(this.state.currentPage+1);
    this.loadLeftPage(this.state.currentPage+2);
    this.loadRightPage(this.state.currentPage+3);
    this.loadLeftPage(this.state.currentPage-2);
    this.loadRightPage(this.state.currentPage-1);
  }
  loadLeftPage = pageNumber => {
    if (pageNumber <= 0 || pageNumber > this.state.catalogInfo.pages) {
      if (pageNumber !== this.state.currentPage || !this.leftPage) return;
      this.setState({
        leftPage:null,
        leftPageSize: {
          width: 0,
          height: this.state.catalogInfo.height,
        }
      }, () => {
      });
      return;
    }
    if (this.loadingPageNumbers.indexOf(pageNumber) >= 0) return;
    if (this.pageCache.hasOwnProperty(pageNumber)) {
      if (pageNumber !== this.state.currentPage || !this.leftPage) return;
      this.leftPage.classList.add('hidden');
      this.setState({
        leftPage:this.pageCache[pageNumber].items,
        leftPageSize: this.pageCache[pageNumber].info
      }, () => {
        this.leftPageVisibleTimer = setTimeout(()=>{
          this.leftPage.classList.remove('hidden');
        }, 100)
      });

      return;
    }

    this.loadingPageNumbers.push(pageNumber);
    API.getDigitalCatalogPage(this.props.catalogId, pageNumber).then(page=>{
      this.pageCache[pageNumber] = page;
      this.loadingPageNumbers.splice(this.loadingPageNumbers.indexOf(pageNumber, 1));
      if (pageNumber !== this.state.currentPage || !this.leftPage) return;
      this.leftPage.classList.add('hidden');
      this.setState({
        leftPage: page.items,
        leftPageSize: page.info
      }, ()=>{
        this.leftPageVisibleTimer = setTimeout(()=>{
          this.leftPage.classList.remove('hidden');
        }, 100);
      });
    });
  }
  loadRightPage = pageNumber => {
    if (pageNumber <= 0 || pageNumber > this.state.catalogInfo.pages) {
      if (pageNumber !== this.state.currentPage+1 || !this.rightPage) return;
      this.setState({
        rightPage:null,
        rightPageSize: {
          width: 0,
          height: this.state.catalogInfo.height,
        }});
      return;
    }
    if (this.loadingPageNumbers.indexOf(pageNumber) >= 0) {
      return;
    }
    if (this.pageCache.hasOwnProperty(pageNumber.toString())) {
      if (pageNumber !== this.state.currentPage+1 || !this.rightPage) return;
      this.rightPage.classList.add('hidden');
      this.setState({
        rightPage:this.pageCache[pageNumber].items,
        rightPageSize: this.pageCache[pageNumber].info
      }, () => {
        this.rightPageVisibleTimer = setTimeout(()=>{
          this.rightPage.classList.remove('hidden');
        }, 100)
          this.bookViewToAll();
      });
      return;
    }

    this.loadingPageNumbers.push(pageNumber);
    API.getDigitalCatalogPage(this.props.catalogId, pageNumber).then(page=>{
      this.pageCache[pageNumber] = page;
      this.loadingPageNumbers.splice(this.loadingPageNumbers.indexOf(pageNumber, 1));
      if (pageNumber !== this.state.currentPage+1 || !this.rightPage) return;
      this.rightPage.classList.add('hidden');
      this.setState({
        rightPage: page.items,
        rightPageSize: page.info
      }, ()=>{
        this.rightPageVisibleTimer = setTimeout(()=>{
          this.rightPage.classList.remove('hidden');
        }, 100);
          this.bookViewToAll();
      });
    });
  }

  /* セキュリティ */
  handleWindowBlur = () => {
    if (this.book) this.book.style.opacity = 0.1;
  }
  handleWindowFocus = () => {
    if (this.book) this.book.style.opacity = 1;
  }
  handelWindowKeydown = e => {
    if (this.book && ['Meta','Alt'].indexOf(e.key) >= 0) this.book.style.opacity = 0.1;
    switch (e.key) {
      case 'ArrowUp':   this.changePrevPage(); break;
      case 'ArrowDown': this.changeNextPage(); break;
      default:
    }
  }
  handelWindowKeyup = e => {
    if (this.book && ['Meta','Alt'].indexOf(e.key) >= 0) this.book.style.opacity = 1;
  }
  handleDragstart = () => {
    window.getSelection().removeAllRanges();
    return false;
  }
  handleContextMenu = e => {
    e.preventDefault(); 
  }

  /* ページ */
  handleChangePageInput = e => {
    e.preventDefault();
    let page = parseInt(e.target.value, 10);
    if (isNaN(page)) return;
    this.setState({page:page});
  }
  handleChangedPageInput = e => {
    if ((e.type === 'keydown' && e.key === 'Enter') || e.type === 'blur' || e.type === 'click') {
      if (this.state.currentPage === this.state.page) return;
      let page = parseInt(this.state.page, 10);
      if (isNaN(page)) page = 0;
      if (page > this.state.catalogInfo.pages) page = this.state.catalogInfo.pages;
      this.setState({page:page, currentPage:page}, () => {
        this.loadPages();
        this.intoScroll();
      });
    }
  }

  /* 拡大率 */
  handleChangedMagnifyInput = e => {
    if ((e.type === 'keydown' && e.key === 'Enter') || e.type === 'blur' ) {
      if (this.state.currentMagnify === this.state.magnify/100) return;
      var bookBnd = this.book.getBoundingClientRect();
      this.setState({currentMagnify:this.state.magnify/100}, ()=>{
        this.changeMagnify(bookBnd);
      });
    }
  }
  handleChangeMagnifyInput = e => {
    e.preventDefault();
    let magnify = parseFloat(e.target.value);
    if (isNaN(magnify)) return;
    this.setState({magnify:magnify});
  }
  handleClickMagnifyDownButton = e => {
    e.preventDefault();
    var bookBnd = this.book.getBoundingClientRect();
    let magnify = Math.round(this.state.magnify*9.5)/10;
    this.setState({magnify: magnify, currentMagnify: magnify/100}, () => {
      this.changeMagnify(bookBnd);
    });
  }
  handleClickMagnifyUpButton = e => {
    e.preventDefault();
    var bookBnd = this.book.getBoundingClientRect();
    let magnify = Math.round(this.state.magnify*10.5)/10;
    this.setState({magnify: magnify, currentMagnify: magnify/100}, () => {
      this.changeMagnify(bookBnd);
    });
  }
  handleClickBookViewToAllButton = e => {
    e.preventDefault();
    this.bookViewToAll();
  }
  handleWheel = e => {
    var bookWrapBnd = this.bookWrap.getBoundingClientRect();
    var prevBookBnd = this.book.getBoundingClientRect();

    let magnify = this.state.magnify * (1 - (e.deltaY/17)*0.05);
    this.setState({
      magnify: magnify,
      currentMagnify: magnify/100
    }, ()=> {
      var updatedBookBnd = this.book.getBoundingClientRect();
      var centerPoint = {
        x: e.clientX - bookWrapBnd.left,
        y: e.clientY - bookWrapBnd.top
      };
      var zoom = updatedBookBnd.width / prevBookBnd.width;
      this.book.style.left = centerPoint.x + (parseInt(this.book.style.left,10) - centerPoint.x) * zoom + 'px';
      this.book.style.top =  centerPoint.y + (parseInt(this.book.style.top,10)  - centerPoint.y) * zoom + 'px';
    });
  }

  // 全面表示
  bookViewToAll = () => {
    let bookWrapBnd = this.bookWrap.getBoundingClientRect();
    var bookSize = {
      width:  this.state.leftPageSize.width + this.state.rightPageSize.width,
      height: Math.max(this.state.leftPageSize.height, this.state.rightPageSize.height)
    };

    var magnify = Math.round(Math.min((bookWrapBnd.width-100)/bookSize.width, (bookWrapBnd.height-40)/bookSize.height)*1000)/10;

    this.book.style.top = (bookWrapBnd.height - Math.round(bookSize.height * magnify/100)) / 2 + 'px';
    this.book.style.left = (bookWrapBnd.width - Math.round(bookSize.width * magnify/100)) / 2 + 'px';

    this.setState({ 
      magnify: magnify,
      currentMagnify: magnify/100
    });
  }

  /* 中心で拡大されるように位置を調整 */
  changeMagnify = (prevBookBnd) => {
    var bookWrapBnd = this.bookWrap.getBoundingClientRect();
    var updatedBookBnd = this.book.getBoundingClientRect();

    var centerPoint = {
      x: bookWrapBnd.width  / 2,
      y: bookWrapBnd.height / 2
    };
    var zoom = updatedBookBnd.width / prevBookBnd.width;
    
    this.book.style.left = centerPoint.x + (parseInt(this.book.style.left,10) - centerPoint.x) * zoom + 'px';
    this.book.style.top =  centerPoint.y + (parseInt(this.book.style.top,10)  - centerPoint.y) * zoom + 'px';
  }

  /* プレビュークリックでページ切り替え */
  handleClickPreviews = e => {
    if (e.target.classList.contains('pair')) {
      let page = parseInt(e.target.dataset.idx, 10) * 2;
      this.setState({
        page: page,
        currentPage: page
      }, ()=>{
        this.loadPages();
      });
    }
  }
  /* 左右ページ送りでページ切り替え */
  handleClickBookWrap = e => {
    if (e.target.classList.contains('prevPageButton') ) this.changePrevPage();
    else if (e.target.classList.contains('nextPageButton') ) this.changeNextPage();
  }
  changePrevPage = () => {
    if (this.state.currentPage > 0) {
      this.setState({
        page: this.state.currentPage-2,
        currentPage: this.state.currentPage-2,
      }, ()=>{
        this.loadPages();
        this.intoScroll();
      });
    }
  }
  changeNextPage = () => {
    if (this.state.currentPage+1 < this.state.catalogInfo.pages) {
      this.setState({
        page: this.state.currentPage+2,
        currentPage: this.state.currentPage+2,
      }, ()=>{
        this.loadPages();
        this.intoScroll();
      });
    }
  }
  intoScroll = () => {
    let pair = this.previews.querySelector('.pair.selected');
    if (!pair) return;
    let rect = pair.getBoundingClientRect();
    let prect = this.previews.getBoundingClientRect();
    if (rect.top >= prect.height+prect.top || rect.bottom <= prect.top ) {
      pair.scrollIntoView({
        block: 'nearest'
      });
    }
  }


    
  /******************************/
  /*  表示位置をドラッグで変更
  /******************************/
  handleMousedownBookWrap = e => {
    this.dragStart = {
      x: e.clientX,
      y: e.clientY
    }

    let dragMoving = (e) => {
      let diffX = this.dragStart.x - e.clientX;
      let diffY = this.dragStart.y - e.clientY;
      this.book.style.left = parseInt(this.book.style.left, 10) - diffX + 'px';
      this.book.style.top  = parseInt(this.book.style.top , 10) - diffY + 'px';

      this.dragStart = {
        x: e.clientX,
        y: e.clientY
      }
    }
    let dragMoved = e => {
      this.bookWrap.removeEventListener('mousemove', dragMoving);
      this.bookWrap.removeEventListener('mouseup', dragMoved);
      this.dragStart = null;
      this.bookWrap.style.cursor = 'grab';
    }
    
    this.bookWrap.addEventListener('mousemove', dragMoving);
    this.bookWrap.addEventListener('mouseup', dragMoved);
    this.bookWrap.addEventListener('mouseleave', dragMoved);
    this.bookWrap.style.cursor = 'grabbing';

  }

  render() {
    return (
      <div className="dialog DigitalCatalogDialog">
        <div className="dialog-window DigitalCatalogDialog-window">
          <div className="DigitalCatalogDialog-windowTitle">
            <button className="closeBtn" onClick={this.props.handleClose}><FontAwesomeIcon icon={faTimes}></FontAwesomeIcon></button>
            <span className="title">{this.props.catalogName}</span>
          </div>
          <LoadingOverlay active={!this.state.catalogInfo} spinner text="読み込み中" className="DigitalCatalogDialog-loading-catalogInfo">
            <div className="DigitalCatalogDialog-body">
              <div className="header">
                <input value={this.state.page} type="number" name="page"
                  min="0" max={this.state.catalogInfo?this.state.catalogInfo.pages:0} step="2" autoComplete="off" 
                  onChange={this.handleChangePageInput} onBlur={this.handleChangedPageInput}  onKeyDown={this.handleChangedPageInput} onClick={this.handleChangedPageInput}/>
                <input value={this.state.magnify} name="magnify" autoComplete="off" 
                  onChange={this.handleChangeMagnifyInput} onBlur={this.handleChangedMagnifyInput} onKeyDown={this.handleChangedMagnifyInput}/>
                <button onClick={this.handleClickMagnifyDownButton}>-</button>
                <button onClick={this.handleClickMagnifyUpButton}>+</button>
                <button onClick={this.handleClickBookViewToAllButton}>全面表示</button>
              </div>
              <div className="view">
                <div className="previews" onClick={this.handleClickPreviews} ref={ref=>{this.previews=ref}}>
                  {this.state.catalogInfo
                    ? Object.keys(this.state.catalogInfo.previews).reduce((carry, key)=>{
                      let n = Math.floor(parseInt(key, 10) / 2);
                      let lr = parseInt(key, 10) % 2 === 0 ? 'l' : 'r';
                      if (!carry.hasOwnProperty(n)) carry[n] = {};
                      carry[n][lr] = {
                        number: key,
                        preview: this.state.catalogInfo.previews[key],
                      };
                      return carry;
                    }, []).map( (pair, idx)=>{
                      if (pair.l && pair.l.preview && pair.r && pair.r.preview) { // サムネールサイズの調整
                        const img = new Image();
                        img.onload = () => {
                          if (img.width >= 100) {
                            this.previews.querySelectorAll('.pair[data-idx="'+idx+'"] img').forEach(imgElm => {
                              imgElm.style.maxWidth = '100px';
                            });
                          }
                        }
                        img.src = pair.l.preview;
                      }
                      return (
                        <div key={idx} className={"pair" + (idx===this.state.currentPage/2?' selected':'')} data-idx={idx}>
                          <div key={idx} className="pageWrap">
                            {pair.hasOwnProperty('l') ? <div key="l" className="page leftPage"><img src={pair.l.preview} alt={pair.l.number}/></div> : null}
                            {pair.hasOwnProperty('r') ? <div key="r" className="page rightPage"><img src={pair.r.preview} alt={pair.r.number}/></div> : null}
                          </div>
                        </div>
                      )
                      })
                    : null}
                </div>
                <div className="bookWrap" ref={ref=>{this.bookWrap=ref}} onClick={this.handleClickBookWrap} onMouseDown={this.handleMousedownBookWrap}>
                  <div className="pageButton prevPageButton"></div>
                  {this.state.catalogInfo
                  ? (
                    <div className="book" ref={ref=>{this.book=ref}}>
                      <div className="page leftPage" ref={ref=>{this.leftPage=ref}} style={{width:this.state.leftPageSize.width*this.state.currentMagnify+'px', height:this.state.leftPageSize.height*this.state.currentMagnify+'px'}}>
                        <div className="images frontIamges">
                        {
                          this.state.leftPage && this.state.leftPage !== 'loading' && this.state.leftPage.length > 0
                          ? this.state.leftPage.map((row, idx)=>{
                            return (
                              <div className="row" key={idx}>
                                {
                                  row.map((p,idx)=>{
                                    return (<img alt="" src={p.g} key={idx} width={p.w*this.state.currentMagnify+'px'} height={p.h*this.state.currentMagnify+'px'}/>)
                                  })
                                }
                              </div>
                            )
                          })
                          : (<div className={"empty"+(this.state.leftPage==='loading'?' loading':'')} style={{width:this.state.leftPageSize.width*this.state.currentMagnify+'px', height:this.state.leftPageSize.height*this.state.currentMagnify+'px'}}>
                              <div className="catalog-loader"></div>
                          </div>)
                        }
                        </div>
                        <div className="images backImages">
                        { /* chrome only */
                          window.chrome && this.state.leftPage && this.state.leftPage !== 'loading' && this.state.leftPage.length > 0
                          ? this.state.leftPage.map((row, idx)=>{
                            return (
                              <div className="row" key={idx}>
                                {
                                  row.map((p,idx)=>{
                                    return (<img alt="" src={p.g} key={idx} width={p.w*this.state.currentMagnify+'px'} height={p.h*this.state.currentMagnify+'px'}/>)
                                  })
                                }
                              </div>
                            )
                          })
                          : null
                        }
                        </div>
                      </div>
                      <div className="page rightPage" ref={ref=>{this.rightPage=ref}} style={{width:this.state.rightPageSize.width*this.state.currentMagnify+'px', height:this.state.rightPageSize.height*this.state.currentMagnify+'px'}}>
                        <div className="images frontImages">
                        {
                          this.state.rightPage && this.state.rightPage !== 'loading' && this.state.rightPage.length > 0
                          ? this.state.rightPage.map((row, idx)=>{
                            return (
                              <div className="row" key={idx}>
                                {
                                  row.map((p,idx)=>{
                                    return (<img alt="" src={p.g} key={idx}  width={p.w*this.state.currentMagnify+'px'} height={p.h*this.state.currentMagnify+'px'}/>)
                                  })
                                }
                              </div>
                            )
                          })
                          : (<div className={"empty"+(this.state.rightPage==='loading'?' loading':'')} style={{width:this.state.rightPageSize.width*this.state.currentMagnify+'px', height:this.state.rightPageSize.height*this.state.currentMagnify+'px'}}>
                            <div className="catalog-loader"></div>
                          </div>)
                        }
                        </div>
                        <div className="images backImages">
                        { /* chrome only */
                          window.chrome && this.state.rightPage && this.state.rightPage !== 'loading' && this.state.rightPage.length > 0
                          ? this.state.rightPage.map((row, idx)=>{
                            return (
                              <div className="row" key={idx}>
                                {
                                  row.map((p,idx)=>{
                                    return (<img alt="" src={p.g} key={idx} width={p.w*this.state.currentMagnify+'px'} height={p.h*this.state.currentMagnify+'px'}/>)
                                  })
                                }
                              </div>
                            )
                          })
                          : null
                        }
                        </div>
                      </div>
                      {/*<div className="watermark">
                        {
                          [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20].map(row=>{
                            return <div className="watermark-row" key={row}>{
                              [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20].map(cell=>{
                                return <div className="watermark-cell" key={cell}><span>Album Support</span></div>
                              })
                            }</div>
                          })
                        }
                      </div>
                      */}
                    </div>
                  )
                  : null
                  }
                  <div className="pageButton nextPageButton"></div>
                </div>
              </div>
            </div>
          </LoadingOverlay>
        </div>
      </div>
    )
  }
}
export default DigitalCatalogDialog;